import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.666 7.33366H8.66602V2.33366C8.66602 2.15685 8.59578 1.98728 8.47075 1.86225C8.34573 1.73723 8.17616 1.66699 7.99935 1.66699C7.82254 1.66699 7.65297 1.73723 7.52794 1.86225C7.40292 1.98728 7.33268 2.15685 7.33268 2.33366V7.33366H2.33268C2.15587 7.33366 1.9863 7.4039 1.86128 7.52892C1.73625 7.65395 1.66602 7.82351 1.66602 8.00033C1.66602 8.17714 1.73625 8.34671 1.86128 8.47173C1.9863 8.59675 2.15587 8.66699 2.33268 8.66699H7.33268V13.667C7.33268 13.8438 7.40292 14.0134 7.52794 14.1384C7.65297 14.2634 7.82254 14.3337 7.99935 14.3337C8.17616 14.3337 8.34573 14.2634 8.47075 14.1384C8.59578 14.0134 8.66602 13.8438 8.66602 13.667V8.66699H13.666C13.8428 8.66699 14.0124 8.59675 14.1374 8.47173C14.2624 8.34671 14.3327 8.17714 14.3327 8.00033C14.3327 7.82351 14.2624 7.65395 14.1374 7.52892C14.0124 7.4039 13.8428 7.33366 13.666 7.33366Z"
      fill="currentColor"
    />
  </svg>
);

const PlusIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default PlusIcon;
